export default __webpack_public_path__ + "static/media/status-inactive.74e3ef09.svg";